import { ranking } from '@/mocks/homeData';

function getRankStyle(rank: number) {
  if (rank === 1) return 'bg-accent-500 text-white';
  if (rank === 2) return 'bg-accent-400 text-white';
  if (rank === 3) return 'bg-accent-300 text-white';
  return 'bg-secondary-200 text-foreground-600';
}

function getChangeIcon(change: string) {
  if (change === 'up') return 'ri-arrow-up-line text-primary-500';
  if (change === 'new') return 'ri-sparkling-line text-accent-500';
  return 'ri-arrow-down-line text-foreground-400';
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4">
            热度排行
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜热度榜
          </h2>
          <p className="text-sm text-foreground-500 mt-2">全网吃瓜话题实时热度排名</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {ranking.map((item, idx) => (
            <a
              key={item.rank}
              href="#carousel"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-50 transition-colors cursor-pointer ${
                idx < ranking.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 ${getRankStyle(item.rank)}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-1.5 shrink-0">
                <i className={`${getChangeIcon(item.change)} text-sm`}></i>
                <span className="text-sm font-semibold text-primary-500 whitespace-nowrap">
                  {item.heat}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}